import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { IconButton, Stack, Typography } from '@mui/material';

type CallListFooterProps = {
  currentPage: number;
  totalPages: number;
  changePage: (direction: 'left' | 'right') => void;
};

const CallListFooter = ({ currentPage, totalPages, changePage }: CallListFooterProps) => {
  if (!totalPages) return <></>;

  return (
    <Stack direction='row' alignItems='center' justifyContent='flex-end' border='1px solid gray' py={1} px={2}>
      <Typography>{`Page ${currentPage + 1} of ${totalPages}`}</Typography>
      <IconButton disabled={currentPage === 0} onClick={() => changePage('left')}>
        <KeyboardArrowLeftIcon />
      </IconButton>
      <IconButton disabled={currentPage + 1 === totalPages} onClick={() => changePage('right')}>
        <KeyboardArrowRightIcon />
      </IconButton>
    </Stack>
  );
};

export default CallListFooter;
